<div  class="page-layout blank fullwidth" (scroll)="onScroll()" fusePerfectScrollbar style="height: 1px; overflow-y: scroll; margin-bottom: 5em;    top: 1px;    background: linear-gradient(45deg, #e2e8f8, #F8FAFF);" >
  <div class="page-wrapper">

    <!-- ===== HERO: 2-col grid (image left, info right) ===== -->
    <div class="product-hero">

      <!-- Left: Image Gallery -->
      <div class="product-gallery">
        <div class="main-image-wrapper">

          <span class="badge-discount" *ngIf="selectedItem?.discount">
            {{ selectedItem?.discount }}% off
          </span>

          <span class="badge-sold">
            {{ selectedItem?.raw?.partInfo?.soldCount || 0 }} Units Sold
          </span>
          <span class="badge-stock">
            ⏳ Limited stock at JC Road
          </span>
          <img
            [src]="selectedItem?.image || defaultImage"
            [alt]="selectedItem?.partName"
            class="main-image"
            (error)="onImageError($event)"
          />

        </div>
        <!-- Thumbnail Strip -->
        <div class="thumbnail-strip" *ngIf="clutchList?.length > 1">
    <div 
      class="thumbnail-item"
      *ngFor="let item of clutchList"
      [ngClass]="{ active: item === selectedItem }"
      (click)="selectedItem = item"
    >
      <img [src]="item.image" />
    </div>
  </div>
      </div>
      <!-- Right: Product Info -->
      <div class="product-info">

        <h1 class="product-title">
          {{ selectedItem?.partName || 'Clutch Product' }}
        </h1>

        <!-- Rating -->
        <div class="rating-row">
          <span class="star">&#9733;</span>
          <span class="star">&#9733;</span>
          <span class="star">&#9733;</span>
          <span class="star">&#9733;</span>
          <span class="star">&#9733;</span>
          <span class="rating-count">5 Ratings</span>
        </div>

        <!-- Delivery -->
        <div class="delivery-row">
          <svg class="truck-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
          </svg>
          <span class="delivery-text"> Dispatched in 15 Mins</span>
        </div>

        <!-- Price Box -->
        <div class="price-box">
          <div class="price-row">
              <!-- SELLING PRICE -->
              <span class="current-price">
                  ₹{{ selectedItem?.sellingPrice || 0 }}
              </span>

              <!-- MRP -->
              <span class="original-price" *ngIf="selectedItem?.mrp">
                  ₹{{ selectedItem?.mrp }}
              </span>

              <!-- SAVE -->
              <span class="save-badge" *ngIf="selectedItem?.saveAmount">
                  Save ₹{{ selectedItem?.saveAmount }}
              </span>

          </div>
          <p class="tax-note">Inclusive of all taxes</p>
        </div>

        <!-- Add to Cart -->
        <button class="btn-add-cart" (click)="onAddToCart()">
          <!-- <span class="plus-icon">+</span> -->
          ⚡Order Complete Kit
        </button>

      </div>
      <!-- END .product-info -->

    </div>
    <!-- END .product-hero -->
    <!-- ===== CLUTCH KIT UI SWITCH ===== -->
      <div class="kit-wrapper">

      <!-- ══════════════════════════════════════════
          SPLIT UI — 2 variables (!isFullKit)
      ══════════════════════════════════════════ -->
      <div *ngIf="!isFullKit" class="kit-card split">

          <div class="kit-header">
          <h2>Clutch Kit – Complete Set</h2>
          <p>All parts included. No need to buy anything else.</p>
          </div>

          <p class="section-title">WHAT YOU GET</p>
          <!-- CLUTCH SET ROW — badge INSIDE this box -->
          <div class="split-row-parent">
              <div class="split-row">
              <div class="row-top">
                  <div class="left">
                  <div class="icons">
                      <div class="icon bg-yellow">💿</div>
                      <div class="icon bg-blue">⚙️</div>
                  </div>
                  <div class="info">
                      <h4>Clutch Set</h4>
                      <span class="sub">Includes {{ clutchList[0]?.partName || 'Includes parts' }}</span>
                      <div class="right">
                          <span class="price-val">₹{{ clutchList[0]?.sellingPrice || 0 }}</span>
                          <span class="price-tag">Clutch Set price</span>
                      </div>
                      <div class="badge">✔ Pre-assembled set</div>
                  </div>
                  </div>
              </div>
              <!-- badge sits inside the box, below the row -->
              
              </div>

              <!-- BEARING ROW -->
              <div class="split-row" *ngIf="clutchList.length > 1">
              <div class="row-top">
                  <div class="left">
                  <div class="icon bg-gray">🔩</div>
                  <div style="display: block;">
                      <div class="info">
                          <h4>  {{ clutchList[1]?.partName || 'Part 2' }}</h4>
                          <span class="sub">  {{ clutchList[1]?.partName || '' }}</span>
                      </div>
                      <div class="right">
                          <span class="price-val">₹{{ clutchList[1]?.sellingPrice || 0 }}</span>
                          <span class="price-tag"> {{ clutchList[1]?.partName || 'Part' }} price</span>
                      </div>
                  </div>
                  </div>
              </div>
              </div>
          </div>
          <!-- <div class="included-bar">
          ✅ (  {{ selectedItem?.partName || '' }} +  {{ clutchList[1]?.partName || '' }} included)
          </div> -->
          <div class="included-bar"> ✅ Complete kit ( {{ selectedItem?.partName }} <span *ngIf="clutchList.length > 1">   + {{ clutchList[1]?.partName }} </span> included)</div>

          <!-- PRICE BREAKDOWN BOX -->
          <div class="price-breakdown">
          <p class="pb-label">PRICE BREAKDOWN</p>

          <div class="pb-divider"></div>

          <div class="pb-row" *ngFor="let item of clutchList">
              <span class="pb-name">{{ item?.partName }}</span>
              <span class="pb-val">₹{{ item?.sellingPrice || 0 }}</span>
          </div>

          <div class="pb-divider"></div>

          <div class="pb-total">
              <h3>₹{{ totalPrice | number:'1.2-2' }}</h3>
              <span>Final price • Full kit</span>
          </div>
          </div>

          <!-- DELIVERY — row -->
          <p class="section-title top-gap">DELIVERY TIMELINE</p>
          <div class="delivery-row">
          <div class="delivery-card blue">
              <div class="d-icon">⏱️</div>
              <p>Ready in 15 mins</p>
              <span>Dispatch time</span>
          </div>
          <div class="delivery-card green">
              <div class="d-icon">🚚</div>
              <p>Free Shipping</p>
              <span>To your location</span>
          </div>
          </div>

          <div class="benefits">
          <div>🛡️ Warranty Certificate Included</div>
          <div>✅ 100% Genuine Parts</div>
          </div>

          <div class="stock-warning">⚡ Limited stock at JC Road</div>

      </div>


      <!-- ══════════════════════════════════════════
          FULL KIT UI — 1 variable (isFullKit)
      ══════════════════════════════════════════ -->
      <div *ngIf="isFullKit" class="kit-card full">

          <div class="kit-header">
          <h2>Clutch Kit – Complete Set</h2>
          <p>All parts included. No need to buy anything else.</p>
          </div>

          <p class="section-title">WHAT YOU GET</p>

          <!-- 3 icon tiles — flex row -->
          <div class="items-row">
              <div class="item" *ngFor="let item of clutchList">
                  <div class="icon bg-yellow">⚙️</div>
                  <span>{{ item?.partName }}</span>
              </div>
          </div>

          <div class="included-bar center">✅ All included in this kit</div>

          <div class="kit-price">
          <h3>₹{{ (selectedItem?.sellingPrice || 0) +    (clutchList[1]?.sellingPrice || 0) +    (clutchList[2]?.sellingPrice || 0) }}</h3>
          <span>Final price • Full kit</span>
          </div>

          <!-- DELIVERY — row -->
          <p class="section-title top-gap">DELIVERY TIMELINE</p>
          <div class="delivery-row">
          <div class="delivery-card blue">
              <div class="d-icon">⏱️</div>
              <p>Ready in 15 mins</p>
              <span>Dispatch time</span>
          </div>
          <div class="delivery-card green">
              <div class="d-icon">🚚</div>
              <p>Free Shipping</p>
              <span>To your location</span>
          </div>
          </div>

          <div class="benefits">
          <div>🛡️ Warranty Certificate Included</div>
          <div>✅ 100% Genuine Parts</div>
          </div>

          <div class="stock-warning">⚡ Limited stock at JC Road</div>

      </div>

      </div>
    <!-- ===== AVAILABILITY BAR — full width, outside grid ===== -->
    <div class="availability-bar">
      <div class="availability-left">
        <div class="avail-icon-wrap">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
          </svg>
        </div>
        <div class="avail-text">
          <span class="avail-title">Check Physical Availability Near You</span>
          <span class="avail-sub">Find the nearest Autoverse store with this product in stock</span>
        </div>
      </div>
      <button class="btn-check-avail" (click)="checkAvailability()">Check Availability</button>
    </div>

    <!-- ===== PRODUCT SPECIFICATIONS — full width, outside grid ===== -->
    <div class="specs-section">
      <h2 class="specs-heading">Product Specifications</h2>

      <div class="specs-grid">
        <!-- Left Card -->
        <div class="specs-card">
          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/brand.png" class="spec-icon">
              <span class="spec-label">Brand</span>
            </div>
            <span class="spec-value"> {{ selectedItem?.brand || '-' }}</span>
          </div>
          <div class="spec-divider"></div>

          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/parttype.png" class="spec-icon">
              <span class="spec-label">Part Type</span>
            </div>
            <span class="spec-value">{{ selectedItem?.partType || '-' }}</span>
          </div>
          <div class="spec-divider"></div>

          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/partno.png" class="spec-icon">
              <span class="spec-label">Part Number</span>
            </div>
            <span class="spec-value"> {{ selectedItem?.partNumber || '-' }}</span>
          </div>
        </div>

        <!-- Right Card -->
        <div class="specs-card">
          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/cat.png" class="spec-icon">
              <span class="spec-label">Category</span>
            </div>
            <span class="spec-value"> {{ selectedItem?.category || '-' }}</span>
          </div>
          <div class="spec-divider"></div>

          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/subcat.png" class="spec-icon">
              <span class="spec-label">Subcategory</span>
            </div>
            <span class="spec-value">Clutch Release Bearing</span>
          </div>
          <div class="spec-divider"></div>

          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/warranty.png" class="spec-icon">
              <span class="spec-label">Warranty</span>
            </div>
            <span class="spec-value">12 Months</span>
          </div>
        </div>
      </div>
    </div>
    <div class="features-container">
          <h2 class="title">Why You Should Order From Autoverse</h2>


          <div class="features-row">
          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/genune.png" class="icon" />
          <h3>Genuine Products</h3>
          <p>100% authentic parts from authorized manufacturers with full warranty coverage</p>
          </div>


          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/fast.png" class="icon" />
          <h3>Fast Delivery</h3>
          <p>Express shipping options available with real-time tracking for your peace of mind</p>
          </div>


          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/expert.png" class="icon" />
          <h3>Expert Support</h3>
          <p>Professional assistance from certified technicians available for all queries</p>
          </div>
          </div>


          <div class="mini-features-row">
          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/fastD.png" class="mini-icon" />
          <h4>Fast Delivery</h4>
          <span>Available</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/return.png" class="mini-icon" />
          <h4>Easy Returns</h4>
          <span>Fast Refunds</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/best.png" class="mini-icon" />
          <h4>Best Price</h4>
          <span>Competitive</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/quality.png" class="mini-icon" />
          <h4>Quality</h4>
          <span>Guaranteed</span>
          </div>
          </div>
      </div>
      <div #compatabilityDiv >
          <div class="comapatable">
              <h3 class="faq-title">Check Compatibile Cars</h3>
              <mat-tab-group>
              <div *ngFor="let vehicle of compatability">
                  <mat-tab [label]="vehicle[0]">
                  <table  [ngClass]="isMobile ? 'toggle-comp-btnMobile' : 'toggle-comp-btn'">
                      <tr>
                      <th>Model</th>
                      <th>Fuel</th>
                      <th>Varient</th>
                      <th>Year</th>
                      </tr>
          
                      <tr *ngFor="let model of getVisibleModels(vehicle[1], vehicle[0]); let i = index">
                      <td>{{ model.model }}</td>
                      <td>{{ model.fuelType }}</td>
                      <td>{{ model.description }}</td>
                      <td>{{ model.yearFrom }}-{{ model.yearTo }}</td>
                      </tr>
                  </table>
                  <button (click)="toggleShowMore(vehicle[0])" 
                          [ngClass]="isMobile ? 'toggle-show-btnMobile' : 'toggle-show-btn'"
                          *ngIf="vehicle[1]?.length > 10" >
                      <div style="padding: 5px;">{{ showAllMap[vehicle[0]] ? 'Show Less' : 'Show More' }}</div>
                      <div style=" align-items: center; display: flex;">
                          <i class="material-icons" style="color: white; align-items: center;  display: flex;">
                              {{ showAllMap[vehicle[0]] ? 'expand_less' : 'expand_more' }}
                          </i>
                      </div>
                  </button>
                  </mat-tab>
              </div>
              
              </mat-tab-group>
          </div>
      </div>
  </div>
  <!-- END .page-wrapper -->


  <!-- Overlay -->
  <div class="popup-overlay" *ngIf="showPopup" (click)="closePopup()"></div>

  <!-- Popup -->
  <div class="popup-container" *ngIf="showPopup">
    <div class="popup-header">
      <div>
      <h2><img src="../../../../assets/images/productdetailsimage/warehouse.png">Physical Availability Across Autoverse Warehouses</h2>
      <p>See what's physically available right now. Orders will always be fulfilled from your assigned warehouse.</p>
      </div>
      <button class="close-btn" (click)="closePopup()">✕</button>
    </div>

    <!-- CASE 1: Assigned warehouse has stock -->
    <ng-container *ngIf="hasStockInAssigned">
      <div class="assigned-card available">
        <div class="top-row">
          <span class="title">Your Assigned Warehouse ⭐</span>
          <span class="status available">
          <img src="../../../../assets/images/productdetailsimage/right.png">Available
        </span>
        </div>

        <h3>{{ assignedWarehouseName }}</h3>

        <div class="count-box">{{ assignedWarehouseStock }} </div>
        <p style="margin-top:0;color: #6D6D6D;">Physical Stock</p>

        <p class="small-info">Available for immediate processing</p>
      </div>
  <div class="divider-with-text">
    <span>Stock in Other Autoverse Warehouses</span>
  </div>


  <div class="warehouse-list">

    <div class="warehouse-card" *ngFor="let w of warehouseStock"
        [ngClass]="{ 'out-stock-card': w.stock <= 0  }">

      <!-- Left Section -->
      <div class="left-card">
        <div class="dot" [ngClass]="w.stock <= 0  ? 'dot-out' : 'dot-available'"></div>

        <div class="name-badges">
          <span class="warehouse-name">{{ w.name }}</span>

          <!-- Badges -->
          <span *ngIf="w.badge === 'highest'" class="badge highest">⭐ Highest Availability</span>
          <span *ngIf="w.badge === 'limited'" class="badge limited">⚠️ Limited Qty</span>
        </div>
      </div>

      <!-- Right Section -->
      <div class="right-card">
      <div>
        <span class="count" *ngIf="w.stock >0">{{ w.stock }}</span>
        <span class="count" *ngIf="w.stock <=0">0</span>
        <span class="units-text">Units</span>
      </div>
      <span class="status available" *ngIf="w.stock > 0">
          <img src="../../../../assets/images/productdetailsimage/right.png">Available
        </span>
        <span class="status out"   *ngIf="w.stock <= 0">
          <img src="../../../../assets/images/productdetailsimage/wrong.png">Out of Stock
        </span>
      </div>

    </div>

  </div>


      <div class="success-box">
          <img src="../../../../assets/images/productdetailsimage/check.png">
          <div>
              <p style="font-weight: bold;">Good News!</p>
              <p style="font-size: 10px;"> This part is unavailable in your warehouse but available in other Autoverse warehouses. </p>
          </div>
      </div>
    </ng-container>

    <!-- CASE 2: Assigned has 0 but other warehouses have stock -->
    <ng-container *ngIf="!hasStockInAssigned && hasStockInOther">
      <div class="assigned-card unavailable">
        <div class="top-row">
          <span class="title">Your Assigned Warehouse ⭐</span>
          <span class="status unavailable"><img src="../../../../assets/images/productdetailsimage/wrong.png">Unavailable Right Now</span>
        </div>

        <h3>{{ assignedWarehouseName }}</h3>

        <div class="count-box zero">{{ assignedWarehouseStock }} </div>
        <p style="margin-top:0;color: #6D6D6D;">Physical Stock</p>

        <p class="warning-text">
          This part is not available in your assigned warehouse right now.
        </p>
        <p class="othergarage">Orders from your garage are fulfilled here.</p>
      </div>

      <div class="divider-with-text">
    <span>Stock in Other Autoverse Warehouses</span>
  </div>


  <div class="warehouse-list">

    <div class="warehouse-card" *ngFor="let w of warehouseStock"
        [ngClass]="{ 'out-stock-card': w.stock <= 0  }">

      <!-- Left Section -->
      <div class="left-card">
        <div class="dot" [ngClass]="w.stock <= 0 ? 'dot-out' : 'dot-available'"></div>

        <div class="name-badges">
          <span class="warehouse-name">{{ w.name }}</span>

          <!-- Badges -->
          <span *ngIf="w.badge === 'highest'" class="badge highest">⭐ Highest Availability</span>
          <span *ngIf="w.badge === 'limited'" class="badge limited">⚠️ Limited Qty</span>
        </div>
      </div>

      <!-- Right Section -->
      <div class="right-card">
      <div>
        <span class="count" *ngIf="w.stock >0">{{ w.stock }}</span>
        <span class="count" *ngIf="w.stock <=0">0</span>
        <span class="units-text">Units</span>
      </div>
      <span class="status available" *ngIf="w.stock > 0">
          <img src="../../../../assets/images/productdetailsimage/right.png">Available
        </span>
        <span class="status out"   *ngIf="w.stock <= 0">
          <img src="../../../../assets/images/productdetailsimage/wrong.png">Out of Stock
        </span>
      </div>

    </div>

  </div>


      <div class="success-box">
          <img src="../../../../assets/images/productdetailsimage/check.png">
          <div>
              <p style="font-weight: bold;">Good News!</p>
              <p style="font-size: 10px;"> This part is unavailable in your warehouse but available in other Autoverse warehouses. </p>
          </div>
      </div>
    </ng-container>

    <!-- CASE 3: No stock anywhere -->
    <ng-container *ngIf="noStockAnywhere">
      <div class="assigned-card unavailable">
        <div class="top-row">
          <span class="title">Your Assigned Warehouse ⭐</span>
          <span class="status unavailable"><img src="../../../../assets/images/productdetailsimage/wrong.png">Unavailable Right Now</span>
        </div>

        <h3>{{ assignedWarehouseName }}</h3>

        <div class="count-box zero">{{ assignedWarehouseStock }}</div>
        <p style="margin-top:0;color: #6D6D6D;">Physical Stock</p>

        <p class="nostock-text"><i>info</i>This part is currently not in stock in any Autoverse warehouse.</p>
      </div>
  <div class="divider-with-text">
    <span>Stock in Other Autoverse Warehouses</span>
  </div>

  <div class="warehouse-list">

    <div class="warehouse-card" *ngFor="let w of warehouseStock"
        [ngClass]="{ 'out-stock-card': w.stock <= 0  }">

      <!-- Left Section -->
      <div class="left-card">
        <div class="dot" [ngClass]="w.stock <= 0  ? 'dot-out' : 'dot-available'"></div>

        <div class="name-badges">
          <span class="warehouse-name">{{ w.name }}</span>

          <!-- Badges -->
          <span *ngIf="w.badge === 'highest'" class="badge highest">⭐ Highest Availability</span>
          <span *ngIf="w.badge === 'limited'" class="badge limited">⚠️ Limited Qty</span>
        </div>
      </div>

      <!-- Right Section -->
      <div class="right-card">
      <div>
        <span class="count" *ngIf="w.stock >0">{{ w.stock }}</span>
        <span class="count" *ngIf="w.stock <=0">0</span>
        <span class="units-text">Units</span>
      </div>
        <span class="status available" *ngIf="w.stock > 0">
          <img src="../../../../assets/images/productdetailsimage/right.png">Available
        </span>
        <span class="status out"   *ngIf="w.stock <= 0">
          <img src="../../../../assets/images/productdetailsimage/wrong.png">Out of Stock
        </span>
      </div>

    </div>

  </div>


      <div class="no-stock-box">
        <img src="../../../../assets/images/productdetailsimage/nostock.png">
        <h3>No Stock Available Right Now</h3>
        <p>This part is temporarily unavailable across the entire Autoverse network.</p>
      </div>
    </ng-container>
  </div>
</div>